import { API_BASE_PATH } from '@/js/const/index.js';

const apiRequest = (path, method, body, withHeader = false) => {
  let ACCEPT_LANGUAGE = localStorage.getItem('lang')
    ? localStorage.getItem('lang')
    : localStorage.getItem('nativeLang');

  let options = {
    method,
    headers: {
      'Accept-Language': ACCEPT_LANGUAGE
    }
  };

  if (body) {
    options = Object.assign({}, options, { body });
  }

  if (withHeader) {
    options = Object.assign({}, options, {
      headers: {
        ...options.headers,
        Authorization: `Bearer ${localStorage.getItem('access_token')}`
      }
    });
  }

  return fetch(API_BASE_PATH + path, options).then(response => response.json());
};

export default apiRequest;
